import type { Meta, StoryObj } from "@storybook/react";

import type { TextLinkProps } from "@/ui/core/TextLink";
import TextLink from "@/ui/core/TextLink";

const StoryMeta: Meta<TextLinkProps> = {
  title: "Core/TextLink",
  component: TextLink,
  argTypes: {
    isUnderlined: { control: "boolean" },
    text: { control: "text" },
    url: { control: "text" },
  },
  args: {
    isUnderlined: false,
    text: "Click here",
    url: "https://example.com",
  },
};

type Story = StoryObj<TextLinkProps>;

const Default: Story = {};

const Underlined: Story = {
  args: {
    isUnderlined: true,
  },
};

export { Default, Underlined };

export default StoryMeta;
